import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetStationByIdQuery } from '../api/station/station.api';
import {
    acquireSocketConnection,
    releaseSocketConnection,
    joinStations,
    leaveStations,
    onStationUpdated,
} from '../utils/socket-io';
import { POLLING_INTERVAL_MS, upsertStationInCaches } from '../utils/station-cache';
import { getStationLocationId } from '../utils/station';

export const useStationSocket = (stationId: string | undefined) => {
    const dispatch = useDispatch();
    const { data: station, isLoading, error, refetch } = useGetStationByIdQuery(stationId ?? '', {
        skip: !stationId,
        pollingInterval: POLLING_INTERVAL_MS,
        skipPollingIfUnfocused: true,
    });

    const stationIdentity = station?.data?.identity;
    const locationId = getStationLocationId(station?.data);

    useEffect(() => {
        if (!stationId || !stationIdentity) return;

        acquireSocketConnection();
        joinStations([stationIdentity]);

        const unsubscribe = onStationUpdated(async identity => {
            if (identity !== stationIdentity) return;

            const result = await refetch();
            if (locationId && result.data) {
                upsertStationInCaches(dispatch, locationId, stationId, result.data);
            }
        });

        return () => {
            unsubscribe();
            leaveStations([stationIdentity]);
            releaseSocketConnection();
        };
    }, [stationId, stationIdentity, locationId, dispatch, refetch]);

    return { station, isLoading, error, refetch, locationId };
};
